import styled from "styled-components";
import { Col } from "../../App.styles";

export const EditorHeader = styled.div`
  width: 100%;
  display: flex;

  .nav-item {
    width: 20%;

    .nav-link {
      text-align: center;
      padding-left: 0;
      padding-right: 0;
    }
  }

  .form-label {
    width: 60%;
    align-self: flex-end;
    margin-bottom: 0.125rem;
    font-size: 0.8rem;
  }
`;

export const EditorCol = styled(Col)`
  flex-direction: column;
  margin-bottom: 1rem;
  max-width: 100%;
  position: relative;

  textarea::selection {
    background: #ccc;
  }

  .fr-wrapper {
    height: 250px;
    overflow-y: scroll;
  }

  .fr-box {
    width: 100%;
  }

  .fr-toolbar-open {
    padding-bottom: 0;
  }

  .fr-code {
    min-height: 100%;
  }
`;